import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Container } from 'ui/container'
import { List } from 'features/history/list'

import c from './assets/sass/page.module.scss'
import { SupportIcon } from '../../ui/icons'

const HistoryPage = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const handleFAQ = () => {
        navigate('/faq?category=tapper')
    }

    return (
        <div className={c.component}>
            <div className={c.title}>
                <span className={c.mainTitle}>{t('history.title')}</span>
                <span className={c.subTitle}>{t('history.subtitle')}</span>
                <button type="button" className={c.btn} onClick={handleFAQ}>
                    <SupportIcon />
                </button>
            </div>
            <Container>
                <List />
            </Container>
        </div>
    )
}

export default HistoryPage
